import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loan-det-form',
  templateUrl: './loan-det-form.component.html',
  styleUrls: ['./loan-det-form.component.css']
})
export class LoanDetFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/emp-salary-details/loan-details/loan-det-form/loan-det-form.component.ts